import { IconDefinition } from '@ant-design/icons-angular';

export const MkbCloseOutline: IconDefinition = {
    name: 'mkb-close',
    theme: 'outline',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#F7F7FA"/>
    <line x1="9.03032" y1="8.88889" x2="15.1111" y2="14.9696" stroke="#6D6D73" stroke-width="1.3" stroke-linecap="round"/>
    <line x1="8.88892" y1="14.9696" x2="14.9697" y2="8.88889" stroke="#6D6D73" stroke-width="1.3" stroke-linecap="round"/>
    </svg>
    `
}